import CalculateBillRates from '../components/common/CalculateBillRates/CalculateBillRates';

export function resolveRatesFromPosition(position, company) {
  if (!position) {
    return { pay: '', payRate: '', billRate: '', bill: '' };
  }

  const payRate = position.pay != null && position.pay !== '' ? String(position.pay) : '';
  let billRate = '';

  if (position.bill != null && position.bill !== '') {
    billRate = String(position.bill);
  } else if (payRate) {
    const markUp = position.markUp ?? company?.commonMarkup;
    const calculated = markUp != null && markUp !== '' ? CalculateBillRates(payRate, markUp) : null;
    billRate = calculated != null ? String(calculated) : '';
  }

  return { pay: payRate, payRate, billRate, bill: billRate };
}
